<app-admin-page-model routeName="Utilisateurs client" pageTitle="Liste des utilisateurs client">
  @if (error) {
    <div class="text-warning mt-5">
      <fa-icon icon="exclamation-triangle"/>
      Le service est momentanément indisponible
    </div>
  } @else if (!contacts) {
    <ls-spinner/>
  } @else {
    <div class="ps-0 d-flex justify-content-md-start justify-content-between" style="grid-gap: 1rem;" [formGroup]="form">
      <app-search-bar class="col-md-4" [searchVal]="search" (search)="search = $event; doSearch()" [resultsCount]="contacts.length"></app-search-bar>
      @if(question) {
        <app-select-badge-field class="col-6 col-md-2" [form]="form" [question]="question"></app-select-badge-field>
      }
    </div>

    <ls-dynamic-table currentSort="lastname"
                       sortAsc="true"
                       [paginate]="true"
                       [data]="contacts"
                       [actions]="tableActions"
                       [headers]="tableaHeaders">
      <ng-template let-item>
        <th scope="row" class="d-table-cell d-md-none">
          <a target="_blank"
             [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DContacts%26action%3DDetailView%26record%3D' + item.crmId"
          >{{ item.lastname }} {{ item.firstname }}</a>
        </th>
        <td class="d-none d-md-table-cell">
          <a target="_blank"
             [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DContacts%26action%3DDetailView%26record%3D' + item.crmId"
          >{{ item.lastname }} {{ item.firstname }}</a>
        </td>
        <td class="d-none d-md-table-cell">
          <span class="d-inline d-md-none">Email : </span>
          {{ item.email }}
        </td>
        <td>
          <span class="d-inline d-md-none">Compte : </span>
          @if (item.account) {
            <a target="_blank"
               [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DAccounts%26action%3DDetailView%26record%3D' + item.account.crmId"
            >{{ item.account.name }}</a>
          } @else {
            <span class="text-danger">Aucun compte associé</span>
          }
        </td>
        <td>
          @if(item.contracts.length > 0) {
            <span class="d-inline d-md-none">Contrats : </span>
          } @else {
            <span class="d-inline d-md-none text-danger">Aucun contrats</span>
          }
          @for (contract of item.contracts; track contract) {
            <a target="_blank" title="Voir le contrat"
               [href]="crmUrl + '/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DAOS_Contracts%26action%3DDetailView%26record%3D' + contract.crmId"
               class="d-block d-md-inline mt-1 mb-1" style="zoom: 0.8">
              @if(getCategoryFromProduct(contract.product); as cat) {
                <app-badge class="me-1 ms-1" [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"/>
              }
            </a>
          }
        </td>
        <td class="text-md-center">
          @if (item.referent) {
            <fa-icon icon="check" class="text-success"></fa-icon>
            <span class="d-inline d-md-none text-success"> Uilisateur référent</span>
          } @else {
            <fa-icon icon="times" class="text-black-50"></fa-icon>
            <span class="d-inline d-md-none text-black-50"> Uilisateur simple</span>
          }
        </td>
        <td class="text-md-center">
          @if (item.enabled) {
            <fa-icon icon="check" class="text-success"></fa-icon>
            <span class="d-inline d-md-none text-success"> Uilisateur actif</span>
          } @else {
            <fa-icon icon="times" class="text-danger"></fa-icon>
            <span class="d-inline d-md-none text-danger"> Uilisateur inactif</span>
          }
        </td>
      </ng-template>
    </ls-dynamic-table>
  }

  <app-dynamic-modal-form title="Réactivation de l'utilisateur"
                          [actions]="[{label: 'Réactiver', class: 'btn-primary', icon: 'sync-alt'}]"
                          (onSubmit)="enableUserAsAdmin()"
                          (onCancel)="toActivate = undefined"
                          [object]="toActivate">
    <ng-template let-object="object">
      <p>Êtes-vous sûr de vouloir réactiver l'utilisateur {{ object.email }} ?</p>
    </ng-template>
  </app-dynamic-modal-form>

  <app-dynamic-modal-form title="Désactivation de l'utilisateur"
                          [actions]="[{label: 'Désactiver', class: 'btn-warning', icon: 'user-slash'}]"
                          (onSubmit)="disableUserAsAdmin()"
                          (onCancel)="toDisable = undefined"
                          [object]="toDisable">
    <ng-template let-object="object">
      <p>Êtes-vous sûr de vouloir désactiver l'utilisateur {{ object.email }} ?</p>
    </ng-template>
  </app-dynamic-modal-form>
</app-admin-page-model>

